<template>
	<div class="box" v-loading="loading" :element-loading-text="$t('bc.bc_49')"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div style=" width: 100%; text-align: center; " class="login">
			{{$t('login.login_lbl0')}}
		</div>
		<div style=" width: 100%; text-align: center; margin-top: 10px;" class="login_text">
			{{$t('login.login_lbl1')}}
		</div>

		<el-row style="width: 100%; margin-top: 10px;">

			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="right">

				<el-row style=" text-align: center;" class="loginbg">

					<el-col :span="3">
						<img style="width: 36px; height: 40px;" src="../assets/default/user.png" />
					</el-col>
					<el-col :span="19" style="margin-left: 10px;">
						<el-form-item prop="userid">
							<el-input v-model="ruleForm.userid" placeholder="user@mrhiro.co.jp"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row style="" class="loginbg">
					<el-col :span="3">
						<img style="width: 36px; height: 40px;" src="../assets/default/password.png" />
					</el-col>
					<el-col :span="19" style="margin-left: 10px;">
						<el-form-item prop="password">
							<el-input type="password" auto-complete="new-password" v-model="ruleForm.password"
								placeholder="PASSWORD">
							</el-input>
						</el-form-item>

						<el-row>
							<el-col :span="24">
								<el-checkbox class="check_text" v-model="checked"> {{$t('login.login_lbl2')}}
								</el-checkbox>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" style="text-align: center;">
						<el-button class="btn_text" @click="loginForm">
							{{$t('login.login_lbl3')}}
						</el-button>
					</el-col>
				</el-row>
				<el-row style="width: 80%; margin: auto; margin-top: 20px;text-align: center; ">
					<el-col :span="24">
						<span class="text_2" @click="register">{{$t('login.login_lbl4')}}</span>
					</el-col>
				</el-row>

				<el-row style="width: 80%; margin: auto;margin-top: 20px;text-align: center;" @click="resetPassword">
					<el-col>
						<span class="text_3" @click="resetPassword">{{$t('login.login_lbl5')}}</span>
					</el-col>
				</el-row>

			</el-form>
		</el-row>


	</div>
</template>

<script>
	import bowser from 'bowser'
	
	export default {

		name: 'Login',
		inject: ['reload'],
		data() {
			const validateEmail = (rule, value, callback) => { //请输入账号
				if (value === '') {
					callback(new Error(this.login.login_5));
				}
				var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
				let isok = reg.test(value);
				console.log(isok)
				if (!isok) {
					callback(new Error(this.login.login_6));
				} else {
					callback();
				}
			};

			const validatePwd = (rule, value, callback) => { //请输入密码
				var res = (/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,18}$/)
				if (value === '') {
					callback(new Error(this.login.login_10));
				} else if (!res.test(value)) {

					callback(new Error(this.$t('bc.bc_9')));
				} else {
					callback();
				}
			};
			return {
				loading: false,
				lang: 0,
				ruleForm: {
					userid: '',
					password: '',
				},
				login: {
					login_5: this.$t('Register.Register_lbl12'),
					login_6: this.$t('Register.Register_lbl13'),
					login_10: this.$t('Register.Register_lbl15'),
					login_11: this.$t('Register.Register_lbl18'),
					login_14: this.$t('Register.Register_lbl19'),
					login_15: this.$t('Register.Register_lbl20'),
					login_16: this.$t('Register.Register_lbl21'),
				},
				rules: {
					userid: [{ //提示请输入手机号
						trigger: ['blur', 'change'],
						validator: validateEmail
					}],
					password: [{ //提示请输入密码
						trigger: ['blur', 'change'],
						validator: validatePwd
					}],
				},
				ShowReset: false,
				checked: false

			}
		},
		components: {

		},
		created() {
			
			
			console.log('----判断浏览器版本----')
			var parser = bowser.getParser(window.navigator.userAgent)
			var bVersion = parser.getBrowserVersion();
			var bName = parser.getBrowserName();
			console.log(bName)
			console.log(bVersion)
			
			this.ruleForm.userid = ''
			this.ruleForm.password = ''
			
			if (this.$i18n.locale == 'ja') {
				this.lang = 0
			}
			else if (this.$i18n.locale == 'zh') {
				this.lang = 1
			}
			else if (this.$i18n.locale == 'en') {
				this.lang = 2
			}

		},
		mounted() {
			this.ruleForm.userid = ''
			this.ruleForm.password = ''
		},
		methods: {

			resetPassword() {

				this.$emit("resetPassword");
			},

			register() {
				this.$emit("register");
			},

			// loginForm(){
			// 	this.$emit('loginSubmit')
			// },

			loginForm() {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {

						this.loading = true
						this.$api.post(this.$config.login, {
								// 'YHSEQNUM': localStorage.getItem('YHSEQNUM')
								'sCOMID': '037',
								'sEMAIL': this.ruleForm.userid,
								'sPassword': this.ruleForm.password,
								'sLNGCT': this.lang
							},
							// 请求成功
							success => {
								this.loading = false
								console.log(success)
								if (success.KKDT[0].code == 200) {
									const self = this;

									//保存的账号
									var name = self.ruleForm.userid;
									//保存的密码
									var pass = self.ruleForm.password;
									//判断复选框是否被勾选 勾选则调用配置cookie方法
									if (this.checked) {
										//传入账号名，密码，和保存天数3个参数
										this.setCookie(name, pass, 365);
									} else {
										this.clearCookie
									}
									this.$message.success(this.login.login_11);


									sessionStorage.setItem('log_ditdt', success.KKDT[0].BITDT);
									sessionStorage.setItem('log_comid', success.KKDT[0].COMID);
									sessionStorage.setItem('log_delfg', success.KKDT[0].DELFG);
									sessionStorage.setItem('log_email', success.KKDT[0].EMAIL);
									sessionStorage.setItem('log_famkn', success.KKDT[0].FAMKN);
									sessionStorage.setItem('log_famnm', success.KKDT[0].FAMNM);
									sessionStorage.setItem('log_givkn', success.KKDT[0].GIVKN);
									sessionStorage.setItem('log_givnm', success.KKDT[0].GIVNM);
									sessionStorage.setItem('log_mstid', success.KKDT[0].MSTID);
									sessionStorage.setItem('log_paswd', success.KKDT[0].PASWD);
									sessionStorage.setItem('log_regdt', success.KKDT[0].REGDT);
									sessionStorage.setItem('log_sexct', success.KKDT[0].SEXCT);
									sessionStorage.setItem('log_kkdtcount', success.KKDTCOUNT);
									this.$emit('loginSubmit')

									this.reload();
								} else if (success.KKDT[0].code == '100000') {
									this.loading = false
									this.$message({

										message: this.login.login_14, //该账号未注册
										type: 'error'
									});
								} else if (success.KKDT[0].code == '100001') {
									this.loading = false
									this.$message({
										message: this.login.login_15, //账号或密码错误
										type: 'error'
									});
								}
							},
							// 请求失败
							error => {
								this.loading = false
								this.$message({
									message: this.login.login_16, //请求失败
									type: 'error'
								});
							}
						)
					} else {
						this.loading = false
						this.$message({
							message: this.$t('bc.bc_36'), //请求失败
							type: 'error'
						});
					}
				});
			},

			//设置cookie
			setCookie(c_name, c_pwd, exdays) {
				var exdate = new Date(); //获取时间
				exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
				//字符串拼接cookie
				window.document.cookie =
					"userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
				window.document.cookie =
					"userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
			},
			//读取cookie
			getCookie: function() {
				//console.log("--读取cookie--"+document.cookie)
				if (document.cookie.length > 0) {
					var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
					for (var i = 0; i < arr.length; i++) {
						var arr2 = arr[i].split("="); //再次切割
						//判断查找相对应的值
						if (arr2[0] == "userName") {
							this.ruleForm.userid = arr2[1]; //保存到保存数据的地方
						} else if (arr2[0] == "userPwd") {
							this.ruleForm.password = arr2[1];
						}
					}
				}
			},
			//清除cookie
			clearCookie: function() {
				this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
			},
			toRefresh() {
				this.$refs['ruleForm'].resetFields();
			}

		}

	}
</script>

<style scoped>
	.box {
		width: 100%;
		height: 100%;
		background-color: #FE9C2C;
	}


	.login_text {
		font-size: 12px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #000000;
	}

	.check_text {

		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #FFFFFF;
	}


	.text_2 {
		font-size: 15px;
		font-family: Noto Sans CJK JP-Black, Noto Sans CJK JP;
		font-weight: 900;
		color: #FFFFFF;
		cursor: pointer;
	}

	.text_3 {
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #0239B5;
		cursor: pointer;
	}

	/deep/ .el-form-item__error {
		color: #000;
	}

	@media only screen and (min-width:680px) {
		.loginbg {
			width: 80%;
			margin: auto;
		}

		.login {
			font-size: 50px;
			font-family: Roboto-Bold, Roboto;
			font-weight: bold;
			color: #000000;
		}

		.btn_text {
			font-size: 18px;
			font-family: Noto Sans CJK JP-Black, Noto Sans CJK JP;
			font-weight: 900;
			color: #FFFFFF;
			width: 250px;
			margin-top: 10px;
			background-color: #000000;
			border-color: #000000;
		}
	}

	@media only screen and (max-width:680px) {
		.loginbg {
			width: 96%;
			margin: auto;
			padding-left: 2%;
			box-sizing: border-box;
		}

		.login {
			font-size: 30px;
			font-family: Roboto-Bold, Roboto;
			font-weight: bold;
			color: #000000;
		}

		.btn_text {
			font-size: 18px;
			font-family: Noto Sans CJK JP-Black, Noto Sans CJK JP;
			font-weight: 900;
			color: #FFFFFF;
			width: 80%;
			margin-top: 10px;
			background-color: #000000;
			border-color: #000000;
		}
		/deep/
		.el-form-item__error{
			font-size: 10px;
		}
	}
</style>